/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FareSubtype,
    FareSubtypeFromJSON,
    FareSubtypeFromJSONTyped,
    FareSubtypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface FareSubtypeFilterItemOutput
 */
export interface FareSubtypeFilterItemOutput {
    /**
     * 
     * @type {string}
     * @memberof FareSubtypeFilterItemOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {FareSubtype}
     * @memberof FareSubtypeFilterItemOutput
     */
    value?: FareSubtype;
    /**
     * 
     * @type {boolean}
     * @memberof FareSubtypeFilterItemOutput
     */
    isEffective?: boolean;
}

export function FareSubtypeFilterItemOutputFromJSON(json: any): FareSubtypeFilterItemOutput {
    return FareSubtypeFilterItemOutputFromJSONTyped(json, false);
}

export function FareSubtypeFilterItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareSubtypeFilterItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : FareSubtypeFromJSON(json['value']),
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function FareSubtypeFilterItemOutputToJSON(value?: FareSubtypeFilterItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'value': FareSubtypeToJSON(value.value),
        'isEffective': value.isEffective,
    };
}


